import { SvgIcon } from '@material-ui/core';

function CheckboxIcon() {
  return (
    <SvgIcon>
      <path d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM5 6v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1z" />
    </SvgIcon>
  );
}

export default CheckboxIcon;
